import { useAccountDeletion } from '../hooks/useAccountDeletion.js';

export function MobileAccountDeletion() {
  const deletion = useAccountDeletion();

  return (
    <>
      <section className="mobile-account-danger-card" aria-label="계정 관리">
        <div><h2>사이트 계정 관리</h2><p>갤로그·게임 프로필·유니온 연결을 포함한 사이트 데이터를 관리합니다.</p></div>
        <button type="button" onClick={deletion.openDialog}>계정 삭제</button>
      </section>

      {deletion.open ? (
        <div className="mobile-account-delete-overlay" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) deletion.closeDialog(); }}>
          <section className="mobile-account-delete-sheet" role="dialog" aria-modal="true" aria-labelledby="mobile-delete-title">
            <div className="mobile-account-delete-grabber" aria-hidden="true" />
            <p className="section-eyebrow">DANGER ZONE</p>
            <h2 id="mobile-delete-title">계정 영구 삭제</h2>
            <p>삭제 후에는 복구할 수 없습니다. 아래에 <strong>계정 삭제</strong>를 입력하고 삭제 동의에 체크해주세요.</p>
            <form onSubmit={deletion.submit}>
              <label><span>삭제 확인 문구</span><input type="text" value={deletion.confirmationText} onChange={(event) => deletion.setConfirmationText(event.target.value)} placeholder="계정 삭제" autoComplete="off" autoFocus disabled={deletion.submitting} /></label>
              <label className="mobile-account-delete-check"><input type="checkbox" checked={deletion.acknowledged} onChange={(event) => deletion.setAcknowledged(event.target.checked)} disabled={deletion.submitting} /><span>삭제된 계정은 복구할 수 없음을 확인했습니다.</span></label>
              {deletion.notice.message ? <p className={`mobile-account-delete-notice ${deletion.notice.type}`} role="status">{deletion.notice.message}</p> : null}
              <div className="mobile-account-delete-actions"><button type="button" onClick={deletion.closeDialog} disabled={deletion.submitting}>취소</button><button type="submit" className="danger" disabled={!deletion.canDelete || deletion.submitting}>{deletion.submitting ? '삭제 중…' : '계정 영구 삭제'}</button></div>
            </form>
          </section>
        </div>
      ) : null}
    </>
  );
}
